import { render, staticRenderFns } from "./HeadTipsGroup.vue?vue&type=template&id=30f6836d&scoped=true"
import script from "./HeadTipsGroup.vue?vue&type=script&lang=js"
export * from "./HeadTipsGroup.vue?vue&type=script&lang=js"
import style0 from "./HeadTipsGroup.vue?vue&type=style&index=0&id=30f6836d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f6836d",
  null
  
)

export default component.exports